// PKGV.D2 (#802) — pure gating logic for PKGCanvas's onConnect -> onEdgeAdd
// wiring, extracted so it's directly unit-testable without simulating a
// real React Flow drag-to-connect gesture in a DOM environment with no
// real layout engine (happy-dom) — same "factor the logic out for
// testability" pattern edgeStyleFor/buildEdgeId already use in
// edgeStyle.ts. PKGCanvas.tsx's handleConnect callback is a thin wrapper
// around this function; behavior lives here, not duplicated in the test.

import type { Connection } from '@xyflow/react';
import type { InteractionLevel } from '@blueprint/shared';

export interface EdgeAddSignal {
  fromNodeId: string;
  toNodeId: string;
}

/**
 * Returns the signal to forward to the caller's `onEdgeAdd`, or `null` if
 * this connect event shouldn't fire one — either because the canvas
 * isn't in editable mode, no `onEdgeAdd` callback was provided, or React
 * Flow's `Connection` is missing a source/target (shouldn't happen in
 * practice, defensive).
 */
export function resolveEdgeAddSignal(
  interactionLevel: InteractionLevel,
  onEdgeAdd: ((connection: EdgeAddSignal) => void) | undefined,
  connection: Connection,
): EdgeAddSignal | null {
  if (interactionLevel !== 'editable' || !onEdgeAdd) return null;
  if (!connection.source || !connection.target) return null;
  return { fromNodeId: connection.source, toNodeId: connection.target };
}
